"use client";

import React, { useEffect, useState, useRef } from "react";
import { useAppSelector } from "@/redux/store";
import {
  getUserInfoById,
  updateUser,
} from "@/helpers/server-actions/users-collection";
import { User } from "@/models/user";
import { useDispatch } from "react-redux";
import { userDetails } from "@/redux/features/app-slice";
import { userSignUpFormSteps } from "@/helpers/utils/constants";
import SignUpFormRenderer from "../signUpFormField/SignUpFormRenderer";
import Image from "next/image";
import { IdTokenResult } from "firebase/auth";

export default function SignUpForm() {
  const childRef = useRef<any>();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true);
  const [steps, setSteps] = useState(userSignUpFormSteps);
  const Loading = useAppSelector((state) => state.appReducer.Loading);
  const userData = useAppSelector((state) => state.appReducer.userData);
  const auth = useAppSelector((state) => state.appReducer.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth || !auth.isAuth || !auth.user) return;
    if (auth.user.displayName) {
      SetName(auth.user.displayName);
    }

    if (auth.user) {
      const modifiedFormSteps = auth.user.phoneNumber !== null
        ? userSignUpFormSteps
        : userSignUpFormSteps.filter(step => step.id !== 1);
      setSteps(modifiedFormSteps);
    }


    if (auth.user.uid.startsWith("linkedin:")) {
      auth.user.getIdTokenResult().then((idTokenResult: IdTokenResult) => {

        const claims = idTokenResult.claims;
        const name = claims["name"] as string;
        if (!!name) {
          SetName(name);
        }
      });
    }
  }, [auth]);

  const SetName = (name: string) => {
    const index = name.indexOf(" ");
    const firstname = name.slice(0, index).trim();
    const lastname = name.slice(index).trim();
    setSteps((prev) => {
      const yourSelfSectionId = 1;
      const obj = prev.find((x) => x.id == yourSelfSectionId);
      if (!obj) return prev;
      const firstnameQuestion = obj?.questions.find(
        (y) => y.slug == "firstName"
      );
      const lastnameQuestion = obj?.questions.find((y) => y.slug == "lastName");
      if (firstnameQuestion) {
        firstnameQuestion.value = firstname;
      }
      if (lastnameQuestion) {
        lastnameQuestion.value = lastname;
      }
      const newState = prev.filter((x) => x.id != yourSelfSectionId);
      newState.unshift(obj);
      return newState;
    });
  };

  const formDataValidate = (value: any) => {
    setIsDisabled(value);
  };

  const preparePayload = (formOutput: any) => {
    if (formOutput && formOutput.questions.length > 0) {
      const newObj = {} as any;
      let questions = formOutput.questions;
      for (let i = 0; i < questions.length; i++) {
        newObj[questions[i].slug] = questions[i].value;
      }
      const updatedUser: User = {
        ...userData,
        ...newObj,
      };
      return updatedUser;
    }
  };

  const updateUserInfo = async () => {
    if (selectedIndex <= steps.length - 1) {
      if (selectedIndex < steps.length - 1) {
        setSelectedIndex(selectedIndex + 1);
        setIsDisabled(true);
      }

      let formOutput = childRef.current.getStepFormData();
      let payload = preparePayload(formOutput) as any;

      const result = await updateUser(payload);
      if (result && userData?.uid) {
        const updatedUser = await getUserInfoById(userData?.uid);
        if (updatedUser) {
          dispatch(userDetails(updatedUser));
        }
      }
    }
  };

  if (Loading.isLoading) {
    return <></>;
  }

  const handleBackButton = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center md:mt-0 mt-[6.25rem]">
        <div className="relative flex flex-col m-4 p-0 shadow-2xl rounded-2xl md:space-y-0 bg-white bg-opacity-70">
          <div className="flex justify-start flex-col mx-10 mt-7 mb-3">
            {selectedIndex > 0 && (
              <button onClick={handleBackButton} className="mb-2">
                <Image
                  height={22}
                  width={22}
                  src="/images/back_button_login.svg"
                  alt="c-tribe"
                />
              </button>
            )}

            <div className="flex flex-col py-2">
              <span className="text-left font-semibold text-[1.375rem] leading-8 text-custom-gray">
                {steps[selectedIndex]?.questionGuide?.title}
              </span>
              <span className="text-left font-normal text-sm leading-5 text-custom-gray mt-1 w-[17.938rem]">
                {steps[selectedIndex]?.questionGuide?.body}
              </span>
            </div>
            {steps && (
              <SignUpFormRenderer
                formSteps={steps}
                formDataValidate={formDataValidate}
                formIndex={selectedIndex}
                ref={childRef}
              />
            )}

            <div className="flex justify-center items-center">
              <button
                onClick={updateUserInfo}
                disabled={isDisabled}
                className={`flex justify-center items-center font-bold p-2 mt-6 rounded-full mb-6 ${isDisabled ? "cursor-not-allowed" : ""
                  } ${isDisabled
                    ? "bg-button-disabled-color bg-opacity-70"
                    : "bg-button-enabled-color"
                  } ${isDisabled ? "text-[#616161]" : "text-white"}`}
                style={{
                  width: "16.875rem",
                  lineHeight: "1.313rem",
                  fontSize: "0.875rem",
                }}
              >
                {steps[selectedIndex]?.questionGuide?.title === "Email Address" ? "Continue" : selectedIndex === steps.length - 1 ? "Finish" : "NEXT"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
